<template>
  <div class="min-h-screen">
    <main>
      <!-- Page header -->
      <div
        class="mx-auto grid grid-cols-1 gap-6 sm:px-6 lg:grid-flow-col-dense lg:grid-cols-3"
      >
        <div class="space-y-6 lg:col-start-1 lg:col-span-2">
          <!-- Description list-->
          <section aria-labelledby="applicant-information-title">
            <div class="bg-white shadow sm:rounded-lg">
              <div class="px-4 py-5 sm:px-6">
                <h2
                  id="applicant-information-title"
                  class="text-lg leading-6 font-medium text-gray-900"
                >
                  {{ $t('message.flow.flow.flujoultimas') }}
                </h2>
              </div>
              <div class="border-t border-gray-200 px-4 py-5 sm:px-6">
                <div id="chart">
                  <apexchart
                    type="rangeBar"
                    height="550"
                    :options="chartOptions"
                    :series="records"
                  ></apexchart>
                </div>
              </div>
            </div>
          </section>
        </div>

        <section
          aria-labelledby="timeline-title"
          class="lg:col-start-3 lg:col-span-1 "
        >
          <recordpanel :selectedorder="selectedorder" />
        </section>
      </div>
    </main>
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts';
import FlowRecordPanel from '@/components/flow/FlowRecordPanel';
import dayjs from 'dayjs';
import { utclocaliso } from '@/utils/utils';
export default {
  name: 'flow-dashboard',
  components: {
    apexchart: VueApexCharts,
    recordpanel: FlowRecordPanel
  },
  created() {
    this.fetchRecords();
  },
  methods: {
    async fetchRecords() {
      const response = await this.$http.get(`flow/custom/timeline`);
      this.records = response.data.records.map(record => {
        return {
          name: record.name,
          data: record.data.map(coord => {
            console.log(coord.y[0], new Date(utclocaliso(coord.y[0])));
            return {
              x: coord.x,
              y: [
                new Date(utclocaliso(coord.y[0])).getTime(),
                new Date(utclocaliso(coord.y[1])).getTime()
              ]
            };
          })
        };
      });
      console.log(JSON.parse(JSON.stringify(this.records)));
    }
  },
  data() {
    return {
      selectedorder: '',
      records: [],
      chartOptions: {
        chart: {
          type: 'rangeBar',
          events: {
            dataPointSelection: (event, context, x) => {
              this.selectedorder = this.records[x.seriesIndex].data[
                x.dataPointIndex
              ].x;
            }
          }
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '80%',
            rangeBarGroupRows: true
          }
        },
        xaxis: {
          type: 'datetime',
          labels: {
            datetimeUTC: false
          },
          max: new Date().getTime(),
          min: new Date(
            dayjs()
              .subtract(1, 'day')
              .format()
          ).getTime()
        },
        stroke: {
          width: 1
        },
        fill: {
          type: 'solid',
          opacity: 0.6
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left'
        }
      }
    };
  }
};
</script>
